export { default as reducer } from './reducer';
